import Head from "next/head";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import { getLocale } from "@/helpers/locales";

export const MetaTagsSubhome = (props) => {

  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};
  // si no tengo props, busco contexto
  if (Object.keys(props).length === 0 && !!formatContent) {
    props = {
      ...props,
      ...formatContent?.dataMetaTagsSubhome,
    };
  }

  const { metas = [], title, url, section, imageWeb, metaDescription, keywords } = props;

  const dataUrl = (url !== '') ? url : section.toLowerCase();
  const locale = getLocale(dataUrl, section);
//mandar Argentina si no viene la sección
  const sectionName = section && section.trim() !== "" ? section : "Argentina";
  const pageTitle = locale.seo?.title || title;
  const ogTitle = locale.seo?.title || `Noticias de ${sectionName}`;

  const getDescription = () => {
    if (locale.seo?.description) return locale.seo.description;
    if (metaDescription) return metaDescription;
    if (dataUrl && dataUrl.includes("recetas")) return locale.descriptions.recetas;
    return locale.descriptions.default(sectionName);
  };

  const description = getDescription();

  let originalUrl = process.env.NEXT_PUBLIC_DOMAIN_URL + "/" + dataUrl;
  let cleanedUrl = '';
  if (typeof originalUrl === 'string' && originalUrl.trim() !== '') {
    try {
      const urlObj = new URL(originalUrl);
      cleanedUrl = urlObj.origin + urlObj.pathname;
    } catch (error) {
      console.error('Invalid URL:', error);
    }
  }
  if (dataUrl == "clarin80") {
    cleanedUrl = "https://www.clarin80.com";
    
  }

  return (
    <Head>
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle}></meta>
      {locale?.geo && (
        <>
          <meta name="geo.region" content={locale.geo.region} />
          <meta name="geo.country" content={locale.geo.country} />
        </>
      )}
      <meta property="og:locale" content={locale?.ogLocale} />
      {locale?.hreflang && (
        <link rel="alternate" hrefLang={locale.hreflang?.lang} href={locale.hreflang?.landingUrl} />
      )}
      {locale?.hreflanges && (
        <link rel="alternate" hrefLang={locale.hreflanges?.lang} href={locale.hreflanges?.landingUrl} />
      )}
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, user-scalable=yes"></meta>
      {imageWeb &&
      <> 
        <link
        rel="preload"
        href={imageWeb.desktop.image ?? ""}
        as="image"
        media="(min-width: 975px)" 
        />
        <link
        rel="preload"
        href={imageWeb.mobile.image ?? ""}
        as="image"
        fetchpriority="high"
        media="(max-width: 974px)" 
      />
      </>
      }
      <meta name="distribution" content="Global" />
      <meta name="robots" content="all" />
      <meta name="author" content="Clarin.com" />
      <meta
        name="classification"
        content="noticias, información, videos, diario, newspaper"
      />
      <meta name="Googlebot" content="all" />
      <meta name="generator" content="Clarin.com | Diario Clarín" />
      <meta name="subject" content="Clarin.com | Diario Clarín" />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta
        name="abstract"
        content="Clarin.com noticias de la Argentina y el mundo actualizadas las 24 horas"
      />
      <meta name="msApplication-ID" content="App" />
      <meta
        name="msApplication-PackageFamilyName"
        content="AGEA.MOBILE.Clarin.com_q59wyq0q7cm24"
      />
      <meta name="msvalidate.01" content="CE3C588E6E296E3426712C2530D6922F" />
      <meta property="og:url" content={cleanedUrl} />
      <meta property="og:title" content={ogTitle} />
      <meta
        property="og:image"
        content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/Clarin_logotag.png`}
      />
      <meta property="og:site_name" content="Clarin.com" />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content={description}
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={locale.seo ? ogTitle : "Clarin.com"} />
      <meta
        name="twitter:description"
        content={description}
      />
      <meta
        name="twitter:image:src"
        content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/clarin-sharing.png`}
      />
      <meta name="twitter:image:alt" content="clarin.com" />
      <meta name="twitter:creator" content="@clarincom" />
      <meta name="twitter:site" content="@clarincom" />
      <meta name="twitter:domain" content="clarin.com" />
      <meta property="twitter:domain" content="https://www.clarin.com"/>
      <meta property="twitter:url" content={cleanedUrl}/>
      <meta property="fb:pages" content="156057357762712" />
      <meta property="fb:pages" content="411588568884731" />
      <meta property="fb:pages" content="349870921749715" />
      <meta property="fb:app_id" content="437491989970687" />
      <meta name="application-name" content="Clarin.com"></meta>
      {metas &&
        metas.map(({ tag, content }) => <meta {...datos} />)}
      <link rel="canonical" href={ cleanedUrl } />
    </Head>
  );
};